import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { ControlValueAccessor, FormControl, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';

import * as moment from 'moment';

import { FileUploader } from 'ng2-file-upload';
import { FileAttachment } from './file-upload.model';

@Component({
  selector: 'oir-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.less'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FileUploadComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FileUploadComponent implements OnInit, ControlValueAccessor {
  public documentUniqueId = moment().format('YYYY-DD-MM h:mm:ss');
  @Input() queueLimit = 1;
  @Input() allowedMimeTypes = [];
  @Input() maxFileSize = 1024 * 1024 * 5;

  @Output() readonly onUploadDocument: EventEmitter<boolean> = new EventEmitter(false);
  @Output() readonly onFormClose: EventEmitter<boolean> = new EventEmitter(false);
  @Output() readonly onError: EventEmitter<void> = new EventEmitter();

  @ViewChild('otherInput', { static: true }) otherInput: any;

  public otherUploader: FileUploader
  documentForm: FormGroup;

  propagateChange = (_: any) => {};
  propagateTouch = (_: any) => {};

  ngOnInit(): void {
    this.otherUploader = new FileUploader({
      url: '',
      allowedMimeType: this.allowedMimeTypes,
      queueLimit: this.queueLimit,
      maxFileSize: this.maxFileSize
    });
    this.documentForm = new FormGroup({
      documentUniqueId: new FormControl(this.documentUniqueId),
      newFileContent: new FormControl(new FormData()),
      attachedDocuments: new FormControl()
    });
    this.otherUploader.onWhenAddingFileFailed = () => {
      this.onError.emit();
    }
    this.documentForm.valueChanges.subscribe(document =>
      this.propagateChange(document)
    );
  }

  writeValue(document: any): void {
    if (document) {
      document.documentDate = moment
        .utc(document.documentDate, ['DD/MM/YYYY'])
        .toISOString();
      this.documentForm.patchValue(document, { emitEvent: false });
    }
  }
  registerOnChange(fn): void {
    this.propagateChange = fn;
  }
  registerOnTouched(fn): void {
    this.propagateTouch = fn;
  }

  replaceFile(): void {
    if (this.otherUploader.queue.length > this.queueLimit) {
      this.deleteFile(this.otherUploader.queue[0]);
    }
    this.otherInput.nativeElement.value = '';
  }

  async upload() {
    this.uploadFileData();
    this.onUploadDocument.emit(true);
  }

  resetForm(): void {
    this.documentForm.reset();
  }
  public noFilesUploaded(): any {
    return this.otherUploader.queue.length === 0;
  }

  private prepareFormData(): FormData {
    const formData = new FormData();
    const fileNames = [];
    this.otherUploader.queue.map((x) => {
      if (x._file.type !== '') {
        formData.append(x._file.name, x._file, x._file.name);
        fileNames.push(x._file.name);
      }
    });
    return formData;
  }

  private uploadFileData(): void {
    const files: FileAttachment[] = [];
    this.otherUploader.queue.map((x) => {
      if (x._file.type !== '') {
        const f: FileAttachment = {
          name: x._file.name,
          content: x._file,
          documentUniqueId: this.documentUniqueId
        };
        files.push(f);
      }
    });
    this.documentForm.get('attachedDocuments').setValue(files);
    this.documentForm.get('documentUniqueId').setValue(this.documentUniqueId);
  }

  private deleteFile(item: any): void {
    item.remove();
  }

  private clearData(): void {
    this.otherUploader.clearQueue();
  }


}
